module.exports = __webpack_public_path__ + "resources/img/bg_cover_marketplace_m.7c065b983c9976f4a0acf6390acb1f04.png";